import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService, PlanTypeEnum } from '../../core';


/**
 * Pipe to convert Plan Type enum to display value.
 */
@Pipe({
	name: 'planTypeLabel'
})
export class PlanTypeLabelPipe implements PipeTransform {

	constructor(private readonly langSrv: LanguageService) { }

	transform(planType: PlanTypeEnum): string {
		return planTypeTranslate(planType, this.langSrv.labels());
	}

}


export const planTypeTranslate = (planType: PlanTypeEnum, labels: any): string => {
	switch (planType) {
		case PlanTypeEnum.Deformity: return labels.PLAN_TYPE_DEFORMITY;
		case PlanTypeEnum.Fracture: return labels.PLAN_TYPE_FRACTURE;
		default: return planType;
	}
}